import ColorSwatch from '@moncler/components/product/ColorSwatch';
import Button from '@ui/button/Button';
import DwFormField from '@ui/formfield/DwFormField';
import createDecorator from 'final-form-focus';
import React, { useCallback, useMemo, useState } from 'react';
import { Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { getSizeVariations } from '@utils/product';
import SelectorSize from '@ui/selector/SelectorSize';
const focusOnError = createDecorator(); // must be outside the component
const NotifyForm = ({ formdef, onSubmit, initialValues, validate, buttonText, product, color, currentSize, showSizeSelector, setCurrentSize }) => {
    const { t } = useTranslation();
    const [error, setError] = useState(false);
    const sizeVariations = useMemo(() => {
        const sizeVariations = getSizeVariations(product);
        if (sizeVariations.length == 1 && !(product === null || product === void 0 ? void 0 : product.isParfum)) {
            setCurrentSize(sizeVariations[0]);
        }
        return sizeVariations;
    }, [product]);
    const productName = useMemo(() => {
        var _a, _b;
        return (product === null || product === void 0 ? void 0 : product.isParfum) ? (_b = (_a = product === null || product === void 0 ? void 0 : product.parfumAttributes) === null || _a === void 0 ? void 0 : _a.productFamily.find((el) => el.format === currentSize.displayValue)) === null || _b === void 0 ? void 0 : _b.name : product === null || product === void 0 ? void 0 : product.productName;
    }, [product]);
    const termsAndConditions = useMemo(() => {
        var _a;
        if (product) {
            return t('notifyme.termsandconditions');
        }
        else {
            const isApp = window.appmode;
            const cookieUrl = (_a = document.getElementById('hidden-cookieurl')) === null || _a === void 0 ? void 0 : _a.href;
            const href = cookieUrl + (isApp ? '?showtopbar=true' : '');
            return t('notifyme.termsandconditionsnoproduct', { 0: href });
        }
    }, [product]);
    const sizeSelection = useCallback(() => {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "selector__menu--size" },
                React.createElement("p", null, t('selector.size')),
                React.createElement("fieldset", { className: "selector-size-expanded" }, sizeVariations === null || sizeVariations === void 0 ? void 0 : sizeVariations.map((variation) => (React.createElement(SelectorSize, { key: variation.id, value: variation.id, label: variation.displayValue, selected: variation.value == (currentSize === null || currentSize === void 0 ? void 0 : currentSize.value), disabled: sizeVariations.length < 2 ? false : product.isComingSoon === 2 || (!variation.selectable && !window.unshoppable), variationGroupId: product.id, onSelect: () => {
                        if (error) {
                            setError(false);
                        }
                        setCurrentSize(variation);
                    } }))))),
            error && (React.createElement("div", { className: "selector__error" },
                React.createElement("span", { className: "errormessage", role: "alert" }, t('label.pleaseselectasize'))))));
    }, [product, currentSize, error]);
    return (React.createElement(React.Fragment, null,
        product && (React.createElement("div", { className: "modal__product-details mt-24" },
            React.createElement("p", { className: "product-details__product-name bold" }, productName),
            color && (React.createElement(React.Fragment, null,
                React.createElement("p", { className: "product-details__product-color" },
                    t('label.color'),
                    ": ", color === null || color === void 0 ? void 0 :
                    color.displayValue,
                    React.createElement("span", { className: "product-details__color-swatch" },
                        React.createElement(ColorSwatch, { variation: color }))))),
            showSizeSelector ? (sizeSelection()) : (React.createElement("p", { className: "product-details__product-size" },
                t('label.size'),
                ": ", currentSize === null || currentSize === void 0 ? void 0 :
                currentSize.displayValue)))),
        formdef && (React.createElement(Form, { onSubmit: onSubmit, initialValues: initialValues, decorators: [focusOnError], validate: (values) => validate(values, formdef), render: ({ handleSubmit, form, submitting, pristine, values }) => (React.createElement("form", { onSubmit: (e) => {
                    if (product && !currentSize) {
                        setError(true);
                        e.preventDefault();
                        return;
                    }
                    handleSubmit(e);
                } },
                React.createElement("fieldset", null,
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-12" },
                            React.createElement(DwFormField, { def: formdef, name: "email", type: "email", autocomplete: "email", idSuffix: "address-field" }))),
                    !product && (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: "row" },
                            React.createElement("div", { className: "col-12 newsletter-modal__gender-wrapper mt-12" },
                                React.createElement(DwFormField, { def: formdef, className: 'gender-selection', name: "gender", type: "radio" }))),
                        React.createElement("div", { className: "row" },
                            React.createElement("div", { className: "col-12 mb-12 privacy-flag-container" },
                                React.createElement(DwFormField, { def: formdef, type: "checkbox", name: "privacyFlag" }))))),
                    product && (React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-12" },
                            React.createElement(DwFormField, { def: formdef, type: "checkbox", name: "emailMarketingConsentFlag" }))))),
                React.createElement("p", { className: "note-required" },
                    React.createElement("small", { className: "note" }, t('label.required'))),
                React.createElement(Button, { type: "submit", disabled: submitting, cls: ['button--primary'] }, buttonText))) })),
        React.createElement("p", null,
            React.createElement("small", { className: "note", dangerouslySetInnerHTML: { __html: termsAndConditions } }))));
};
export default NotifyForm;
